import { Card } from "./style"
import { MdLocationOn } from "react-icons/md"
import { RiNavigationFill } from "react-icons/ri"
import { FiBookmark, FiHeart, FiX } from "react-icons/fi"
import visitorService from "../../../services/visitor"
import { fetchUserCreditionals } from "redux/modules/userDatas/actions"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import works from "services/works"
import { classNames } from "utils/classNames"
import defaultImage from "../../../assets/images/mmbaza-logo-white.png"
import { useTranslation } from "react-i18next"

export default ({
  data,
  xButton,
  handleDelete,
  setRefresh = () => {},
  width = "",
  onClick = () => {},
}) => {
  const token = localStorage.getItem("mmbs_access_token")
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { favourites, saveds, vieweds } = useSelector(
    (state) => state.userDatasReducer
  )

  const checkActive = (id, name) => {
    if (name === "saves") {
      if (saveds.includes(id)) {
        return true
      }
    }
    if (name === "favorites") {
      if (favourites.includes(id)) {
        return true
      }
    }
    if (name === "seens") {
      if (vieweds.includes(id)) {
        return true
      }
    }
  }

  const handleActionBtns = (id, actionType) => {
    // setLoading && setLoading(prev => !prev)
    if (id && token) {
      const postData = {}

      if (actionType === "saves") {
        postData["saved"] = id
        visitorService
          .workUpdate(postData)
          .then(() => {
            dispatch(fetchUserCreditionals())
            setRefresh((prev) => !prev)
          })
          .catch((res) => {
            console.log(res)
          })
      }

      if (actionType === "favorites") {
        postData["selected"] = id
        visitorService
          .workUpdate(postData)
          .then(() => {
            dispatch(fetchUserCreditionals())
            setRefresh((prev) => !prev)
          })
          .catch((res) => console.log(res))
      }
    } else {
      navigate("/auth")
    }
  }

  const handleRoute = (id) => {
    navigate(`/works/detail/${id}`)
    if (token) {
      const postData = { seen: id }
      visitorService
        .workUpdate(postData)
        .then(() => {})
        .catch((res) => {
          console.log(res)
        })
      works
        .seen(id)
        .then(() => {
          dispatch(fetchUserCreditionals())
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      works
        .seen(id)
        .then(() => {})
        .catch((err) => {
          console.log(err)
        })
    }
  }

  return (
    <Card className="rounded-2xl font-[Roboto] bg-white" width={width}>
      <div className="relative max-h-[220px] w-full rounded-2xl overflow-hidden">
        <button
          disabled={checkActive(data?._id, "favorites")}
          onClick={() => handleActionBtns(data?._id, "favorites")}
          className="absolute top-[15px] right-[15px] bg-none disabled:cursor-not-allowed"
        >
          <FiHeart
            size={27}
            className={classNames(
              checkActive(data?._id, "favorites")
                ? "stroke-[#ED4400] fill-[#ED4400]"
                : "stroke-[#fff] fill-[color:#0000003D]",
              "  stroke-1"
            )}
          />
        </button>
        {xButton ? (
          <button
            onClick={() => handleDelete(data?._id)}
            className="inline-block absolute top-[15px] left-[15px] rounded-md bg-[#FFF1F1] p-1"
          >
            <FiX size={20} color="#F36565" />
          </button>
        ) : null}
        <img
          src={data?.media?.length ? data?.media[0]?.image : defaultImage}
          alt=""
          className="object-cover w-full h-[250px]"
        />
      </div>
      <div
        className="main-card text-black px-[14px] pt-[16px] pb-[20px] hover:underline"
        aria-hidden
        onClick={() => handleRoute(data?._id)}
      >
        <h1>{data?.title?.slice(0, 40) + "..." ?? "-"}</h1>
        <p className="pt-[12px]" style={{ overflowWrap: "break-word" }}>
          {data?.desc?.slice(0, 70) + "..."}
        </p>
      </div>
      <div className="footer-card px-[14px]">
        <div className="flex items-center gap-[16px] location-card">
          <div className="px-[4.5px] py-[4.5px] rounded-[6px] icon-block">
            <MdLocationOn size={27} />
          </div>
          <p> {data?.region?.title}</p>
        </div>
        <div className="flex items-center justify-between gap-[16px] pt-[9px]">
          <button
            className="flex items-center gap-[16px] location-card"
            onClick={onClick}
          >
            <div
              className="px-[4.5px] py-[4.5px] rounded-[6px] icon-block"
              style={{ transform: "rotateY(180deg)" }}
            >
              <RiNavigationFill size={27} />
            </div>
            <p>{t("send-route")}</p>
          </button>
          <button
            onClick={() => handleActionBtns(data?._id, "saves")}
            disabled={checkActive(data?._id, "saves")}
            className="disabled:cursor-not-allowed"
          >
            <FiBookmark
              size={27}
              className={classNames(
                checkActive(data?._id, "saves")
                  ? "stroke-[#3399FF] fill-[#3399FF]"
                  : "stroke-[#8B949E]",
                "  stroke-1 "
              )}
            />
          </button>
        </div>
      </div>
    </Card>
  )
}
